import {
  CircularProgress,
  GKTypography,
  Grid2,
  IconButton,
  ReloadIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "components";
import { HoldingDataInterface } from "interfaces/Portfolio";
import { useAppSelector } from "store/store";
import { paletteLightTheme } from "utils/ColorTheme";
import { numberToCurrency } from "utils/MathFunction";

interface Props {
  cardDataLoading: boolean;
  holdingSummaryDetails: HoldingDataInterface;
  xirrLoading: boolean;
  setIsXirrRefresh: (value: boolean) => void;
}

const PortfolioDetailsHeaderCard = (props: Props) => {
  const {
    cardDataLoading,
    holdingSummaryDetails,
    xirrLoading,
    setIsXirrRefresh,
  } = props;

  const userData = useAppSelector((state) => state?.user?.userData);

  return (
    <Grid2 size={12}>
      <TableContainer>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell
                style={{
                  borderRight: `solid 1px ${paletteLightTheme.palette.grey[300]}`,
                  borderBottom: "none",
                  padding: 16,
                  width: "16%",
                }}
              >
                <Typography fontSize={12} color={"var(-neutral-700)"}>
                  Net Contribution
                </Typography>
                <GKTypography
                  fontWeight={600}
                  fontSize={16}
                  color="var(--black)"
                  loading={cardDataLoading}
                >
                  {numberToCurrency(
                    holdingSummaryDetails?.netContribution || 0,
                  )}
                </GKTypography>
              </TableCell>
              <TableCell
                style={{
                  borderRight: `solid 1px ${paletteLightTheme.palette.grey[300]}`,
                  borderBottom: "none",
                  padding: 16,
                  width: "16%",
                }}
              >
                <Typography fontSize={12} color={"var(-neutral-700)"}>
                  Ledger Balance
                </Typography>
                <GKTypography
                  fontWeight={600}
                  fontSize={16}
                  loading={cardDataLoading}
                  color="var(--black)"
                >
                  {numberToCurrency(holdingSummaryDetails?.availableCash || 0)}
                </GKTypography>
              </TableCell>
              <TableCell
                style={{
                  borderRight: `solid 1px ${paletteLightTheme.palette.grey[300]}`,
                  borderBottom: "none",
                  padding: 16,
                  width: "16%",
                }}
              >
                <Typography fontSize={12} color={"var(-neutral-700)"}>
                  Dividend
                </Typography>
                <GKTypography
                  fontWeight={600}
                  fontSize={16}
                  loading={cardDataLoading}
                >
                  {numberToCurrency(holdingSummaryDetails?.otherGains || 0)}
                </GKTypography>
              </TableCell>
              <TableCell
                style={{
                  borderRight: `solid 1px ${paletteLightTheme.palette.grey[300]}`,
                  borderBottom: "none",
                  padding: 16,
                  width: "16%",
                }}
              >
                <Typography fontSize={12} color={"var(-neutral-700)"}>
                  Portfolio Value
                </Typography>
                <GKTypography
                  fontWeight={600}
                  fontSize={16}
                  loading={cardDataLoading}
                  color="var(--black)"
                >
                  {numberToCurrency(holdingSummaryDetails?.portfolioValue || 0)}
                </GKTypography>
              </TableCell>
              <TableCell
                style={{
                  borderRight: `solid 1px ${paletteLightTheme.palette.grey[300]}`,
                  borderBottom: "none",
                  padding: 16,
                  width: "16%",
                }}
              >
                <Typography fontSize={12} color={"var(-neutral-700)"}>
                  Total Gain
                </Typography>
                <GKTypography
                  fontWeight={600}
                  fontSize={16}
                  loading={cardDataLoading}
                  color="var(--black)"
                >
                  {numberToCurrency(holdingSummaryDetails?.totalGains || 0)}
                </GKTypography>
              </TableCell>
              <TableCell
                style={{
                  padding: 16,
                  width: "20%",
                  borderBottom: "none",
                }}
              >
                <Typography
                  fontSize={12}
                  color={"var(-neutral-700)"}
                  display={"flex"}
                  gap={1}
                >
                  Returns
                  {/* {userData?.showTwrr ? "TWRR" : "XIRR"}{" "} */}
                </Typography>
                <Typography
                  fontWeight={600}
                  fontSize={18}
                  color="var(--black)"
                  display={"flex"}
                  alignItems={"center"}
                  gap={1}
                >
                  {userData?.showTwrr
                    ? +holdingSummaryDetails?.twrr?.toFixed(2) || "0"
                    : +holdingSummaryDetails?.xirr?.toFixed(2) || "0"}
                  <Typography
                    fontSize={12}
                    fontWeight={500}
                    color="var(--neutral-500)"
                    display={"flex"}
                    alignItems={"center"}
                    gap={1}
                    component={"span"}
                  >
                    {" "}
                    (*As of{" "}
                    {holdingSummaryDetails?.lastTwrrRefresh
                      ? holdingSummaryDetails?.lastTwrrRefresh
                      : holdingSummaryDetails?.lastRefreshTime}
                    )
                    <Typography component={"span"}>
                      <IconButton
                        sx={{ p: 0 }}
                        disabled={xirrLoading}
                        onClick={() => setIsXirrRefresh(true)}
                      >
                        {xirrLoading ? (
                          <CircularProgress size={13} />
                        ) : (
                          <ReloadIcon
                            width={13}
                            style={{ color: "var(--primary-900)" }}
                          />
                        )}
                      </IconButton>
                    </Typography>
                  </Typography>
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Grid2>
  );
};

export default PortfolioDetailsHeaderCard;
